import { UtmQuery } from 'mk2/apps/home/schemas';
import { SignupFormData } from 'mk2/apps/users/components/SignupForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Signup form

export const SIGNUP_TRIGGER = 'SIGNUP_TRIGGER';
export interface SignupTriggerAction {
    readonly type: typeof SIGNUP_TRIGGER;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
    readonly iframe: boolean;
}
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export interface SignupRequestAction extends APIRequestAction {
    readonly type: typeof SIGNUP_REQUEST;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
}
export interface SignupNormalizedResponse extends NormalizedResponse {
    // readonly result: { topic: number; moderatorsDetails: any; };
}
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export interface SignupSuccessAction extends APISuccessAction<SignupNormalizedResponse> {
    readonly type: typeof SIGNUP_SUCCESS;
    readonly signupFd: SignupFormData;
}
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export interface SignupFailureAction extends APIFailureAction {
    readonly type: typeof SIGNUP_FAILURE;
    readonly signupFd: SignupFormData;
}

export const signupTrigger =  (signupFd: SignupFormData, query: UtmQuery, iframe: boolean): SignupTriggerAction => ({
    type: SIGNUP_TRIGGER, signupFd, query, iframe,
});
export const signupAPI = {
    request: (signupFd: SignupFormData, query: UtmQuery): SignupRequestAction => ({
        type: SIGNUP_REQUEST, signupFd, query,
    }),
    success: (signupFd: SignupFormData, response: SignupNormalizedResponse): SignupSuccessAction => ({
        type: SIGNUP_SUCCESS, signupFd, response,
    }),
    failure: (signupFd: SignupFormData, error: any): SignupFailureAction => ({
        type: SIGNUP_FAILURE, signupFd, error,
    }),
};
